import axios from 'axios';

export function getRoomAvailabilities({ month, page }, options) {
    return axios.post('/plateaux/recherche', {
        month,
        page,
    }, options).then(response => response.data);
}
